import React from 'react'
import ButtonIcon from '@/components/ui/ButtonIcon/ButtonIcon'
import { Crevron } from '@/assets/icons'
import { i18n } from '@/locale/i18n'

/**
 * Floating scroll affordance for horizontal strips (chips, tabs).
 * A fade backdrop dissolves the scrolled content behind the button so the
 * arrow reads as a layer above the strip instead of blending into the items.
 * Position it inside a `relative` wrapper around the scroll container.
 *
 * @param {-1|1} direction -1 scrolls left, 1 scrolls right
 * @param {Function} onClick
 * @param {string} [background] CSS color the fade resolves to (defaults to the page surface)
 */
const ScrollArrow = ({ direction = 1, onClick, background = 'var(--color-surface-1)' }) => (
  // The fade backdrop itself is decorative and ignores pointer events (so the
  // faded items stay clickable) — only the ButtonIcon captures clicks/focus.
  // Not aria-hidden: it wraps a real, keyboard-focusable button, and hiding an
  // ancestor still removes a focusable descendant from the accessibility tree.
  <div
    className={`absolute top-0 bottom-0 z-10 flex items-center w-16 pointer-events-none ${
      direction === -1 ? 'left-0 justify-start' : 'right-0 justify-end'
    }`}
    style={{
      background: `linear-gradient(to ${direction === -1 ? 'right' : 'left'}, ${background} 55%, transparent)`,
    }}>
    <span className="pointer-events-auto">
      <ButtonIcon
        variant="outline"
        size="small"
        cursorPointer
        handleOnClick={onClick}
        ariaLabel={i18n(direction === -1 ? 'common.scroll_left' : 'common.scroll_right')}>
        {/* Crevron hardcodes its own style/transform, so rotate a wrapper instead */}
        <span
          className="flex items-center justify-center"
          style={{ transform: direction === -1 ? 'rotate(90deg)' : 'rotate(-90deg)' }}>
          <Crevron width="12" height="7" fillcolor="var(--color-Neutral-6)" />
        </span>
      </ButtonIcon>
    </span>
  </div>
)

export default ScrollArrow
